import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import DescriptionIcon from '@mui/icons-material/Description';
import '../assets/styles/Main.scss';
import avatar from "../assets/images/me.png";
function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={avatar} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/dominicatrotrias" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/david-nemetz-6a3b6743b" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
            <a href={`${process.env.PUBLIC_URL}/resume.pdf`} target="_blank" rel="noreferrer" aria-label="View Resume"><DescriptionIcon /></a>
          </div>
          <h1>David Michael Nemetz</h1>
          <p>Senior Data Engineer</p>

          <div className="mobile_social_icons">
            <a href="https://github.com/dominicatrotrias" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/david-nemetz-6a3b6743b" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
            <a href={`${process.env.PUBLIC_URL}/resume.pdf`} target="_blank" rel="noreferrer" aria-label="View Resume"><DescriptionIcon /></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;